import React, { Component } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard';
import './App.scss'
import ga from './utils/google'
import 'animate.css'

export class App extends Component {
  state = {
    isDalog:false
  }

  download(){
    const a = this.props.location.search.slice(3) === '01'
    ga()
    let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    let isWeixin = window.navigator.userAgent.indexOf('MicroMessenger') > -1;
    let ua = navigator.userAgent.toLowerCase();
    if(isAndroid && isWeixin || ua.match(/WeiBo/i) === "weibo"){
      this.setState({isDalog:true})
    }else if (isAndroid){
      window.location.href = a ? 'https://youdu-novel.oss-cn-hangzhou.aliyuncs.com/channel/novel01.apk' : 'https://dqy-download.oss-cn-beijing.aliyuncs.com/novel1.0.apk'
    }else if(isiOS){
      window.location.href = a ? 'https://apps.apple.com/app/apple-store/id1460232448?pt=122439200&ct=01&mt=8' : 'https://apps.apple.com/cn/app/id1460232448';
    }
  }

  render() {
    return (
      <>
        <div className={this.state.isDalog? "inviteMask mask86 maskIn":"inviteMask mask86"} id="wechatShareGuide" onClick={this.state.isDalog? ()=>{this.setState({isDalog:false})}:()=>{}}>
          <div className="shareMask">
          </div>
        </div>
        <div className='App animate'>
          <main>
            <div className='logo'>
              <img className='top' src={require('./assets/正版.svg').default} />
              <img className='logo_img' src={require('./assets/youduxiaoshuo.png').default} alt='' />
            </div>
            <div className='desc'>
              <p>有读免费小说</p>
              <span>全网小说免费看，现金奖励赚不停</span>
            </div>
            <CopyToClipboard text={this.props.location.pathname.slice(1).length>0? this.props.location.pathname.slice(1):"inviteCode="}
                onCopy={()=>{this.download()}}>
                <div className='btn animate__animated animate__pulse animate__infinite'>立即下载</div>
            </CopyToClipboard>
            <div className='bottom_desc'>
              <p>本产品向用户提供免费优质数字阅读服务，如有侵权请联系本站删除</p>
              <p>上海市宝山区一二八纪念路968号1205室C区1000室（021-60641888）</p>
              <p>枫杉信息科技（上海）有限公司 - 沪ICP备19004568号</p>
            </div>
          </main>
        </div>
      </>
    )
  }
}

export default App
